export default function suppressOnEdit() {
    return function (event) {
        return event.editing;
    };
}
